export default {
  steps: {
    setup_fee: 'Tarifa de configuración',
    business_info: 'Info de empresa',
    create_preview: 'Crear contrato de vista previa',
    preview: 'Vista previa del contrato',
    sign: 'Firmar contrato',
  },
  buttons: {
    next: 'Vista previa del contrato',
    save_and_continue: 'Guardar y continuar',
    update: 'Actualizar vista previa',
    cancel: 'Cancelar actual',
    skip: 'Omitir creación de contrato',
  },
  create_preview: {
    header: 'Crear contrato de vista previa',
    description: 'Introduce los datos del destinatario del contrato. Aún puedes modificarlos antes de enviarlo.',
  },
  sign: {
    update_notice: 'Para actualizar el contrato, cancela el actual y edita los detalles.',
  },
  toasts: {
    failed_to_save_changes: 'Error al guardar los cambios',
  },
};
